"use client";

import Input from "@client/components/formik/input";
import Fieldset from "@client/components/lead-form/components/fieldset";
import { faCoins } from "@fortawesome/free-solid-svg-icons";
import { faCoin } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setUserInteractionDataAttribute } from "@shared/constants";
import kebabToCamelCase from "@shared/functions/kebabToCamelCase";
import {
	StackedTile,
	StackedTileWrapper,
} from "@ui/js/components/tiles/stacked-tile";
import { useFormikContext } from "formik";

const INPUT_ID_AND_LABEL_HTMLFOR = "tile-test";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function TileTest() {
	const { setFieldValue } = useFormikContext();

	const handleClick = (e: any) => {
		setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
	};
	return (
		<Fieldset legend="How much debt do you owe?">
			<Input
				type="hidden"
				name={FIELD_NAME_SELECTOR}
				id={INPUT_ID_AND_LABEL_HTMLFOR}
			/>
			<StackedTileWrapper>
				<StackedTile
					{...setUserInteractionDataAttribute(
						`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__10k-20k`,
					)}
					icon={<FontAwesomeIcon icon={faCoin} />}
					componentStyle="inverted"
					label="$10k - $20k"
					value="$10k_to_$20k"
					onClick={handleClick}
				/>
				<StackedTile
					{...setUserInteractionDataAttribute(
						`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__20k-40k`,
					)}
					componentStyle="inverted"
					icon={<FontAwesomeIcon icon={faCoins} />}
					label="$20k - $40k"
					value="$20k_to_$40k"
					onClick={handleClick}
				/>
				<StackedTile
					{...setUserInteractionDataAttribute(
						`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__ahhh`,
					)}
					componentStyle="inverted"
					icon={<FontAwesomeIcon icon={faCoins} />}
					label="ahh"
					value="ahhh"
					onClick={handleClick}
				/>
			</StackedTileWrapper>
		</Fieldset>
	);
}
